import { Condition } from '../types/conditionTypes';
import moment from 'moment';

export const mapConditionsToBackendFormat = (conditions: Condition[]) => {
  const result: any = {};

  conditions.forEach(condition => {
    switch (condition.type) {
      case 'sex':
        if (condition.value) {
          result.sex = condition.value;
        }
        break;

      case 'averageTicket':
        if (condition.minValue !== undefined) {
          result.averageTicketMin = condition.minValue;
        }
        if (condition.maxValue !== undefined) {
          result.averageTicketMax = condition.maxValue;
        }
        break;

      case 'channel':
        if (condition.values && condition.values.length > 0) {
          result.purchaseChannelIds = condition.values;
        }
        break;

      case 'age':
        if (condition.minValue !== undefined) {
          result.minAge = condition.minValue;
        }
        if (condition.maxValue !== undefined) {
          result.maxAge = condition.maxValue;
        }
        break;

      case 'brands':
        if (condition.values && condition.values.length > 0) {
          result.brandIds = condition.values;
        }
        break;

      case 'categories':
        if (condition.values && condition.values.length > 0) {
          result.categoryIds = condition.values;
        }
        break;

      case 'level':
        if (condition.value) {
          result.levelId = condition.value;
        }
        break;

      case 'purchaseCount':
        if (condition.minValue !== undefined) {
          result.purchaseCountRange = condition.minValue;
        }
        if (condition.maxValue !== undefined) {
          result.purchaseCountRangeMax = condition.maxValue;
        }
        break;

      case 'purchasesInPeriod':
        if (condition.value !== undefined) {
          result.purchaseCountPeriod = condition.value;
        }
        if (condition.minValue !== undefined) {
          result.purchaseCountLastDays = condition.minValue;
        }
        break;

      case 'purchasesInDateRange':
        if (condition.startDate) {
          result.purchaseCountStartDate = condition.startDate;
        }
        if (condition.endDate && !condition.untilPresent) {
          result.purchaseCountEndDate = condition.endDate;
        }
        break;

      case 'totalSpent':
        if (condition.minValue !== undefined) {
          result.totalSpent = condition.minValue;
        }
        if (condition.maxValue !== undefined) {
          result.totalSpentMax = condition.maxValue;
        }
        break;

      case 'birthday':
        if (condition.startDate) {
          result.birthdayStartDate = moment(condition.startDate).format('YYYY-MM-DD');
          if (condition.endDate && !condition.untilPresent) {
            result.birthdayEndDate = moment(condition.endDate).format('YYYY-MM-DD');
          }
        }
        break;

      case 'registrationDate':
        if (condition.startDate) {
          result.programRegistrationStartDate = moment(condition.startDate).format('YYYY-MM-DD');
          if (condition.endDate && !condition.untilPresent) {
            result.programRegistrationEndDate = moment(condition.endDate).format('YYYY-MM-DD');
          }
        }
        break;

      case 'city':
        if (condition.value) {
          result.stateId = condition.value;
        }
        break;

    }
  });

  return result;
};
